app.controller('OrderQuoteDefaultController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $rootScope.service.account.requireMinimumData(function () {
        $scope.view_model = {
            webquote_defaults: $rootScope.model.account.user_data.webquote_defaults ? $rootScope.model.account.user_data.webquote_defaults : {}
        }
    })

    $scope.saveQuoteDefaults = function (validateFormCallback) {

        $rootScope.service.order_quote.saveQuoteDefaults($scope.view_model.webquote_defaults, function (success, data, messages) {
            validateFormCallback(success, messages);
        })

    };

    $scope.startNewQuote = function () {
        $rootScope.service.order.startNewOrder(true);
        $state.go('myba.dashboard');
    }

}]);